import axios from "@/libs/api.request";
// 获取列表
export const getList = params => {
  return axios.request({
    url: "/cost/rule",
    params,
    method: "get"
  });
};
// 创建列表
export const add = data => {
  return axios.request({
    url: "/cost/rule",
    data,
    method: "post"
  });
};
// 获取详情
export const getDetails = id => {
  return axios.request({
    url: `/cost/rule/${id}`,
    method: "GET"
  });
};
// 更新列表
export const update = data => {
  return axios.request({
    url: `/cost/rule/${data.id}`,
    method: "put",
    data
  });
};

// 删除列表
export const del = data => {
  return axios.request({
    url: `/cost/rule/${data.id}`,
    method: "DELETE"
  });
};

export const getRule = data => {
  return axios.request({
    url: `/cost/rule/getRule`,
    method: "get",
  });
};

export const getUser = params => {
  return axios.request({
    url: `/cost/rule/getUser`,
    method: "get",
		params
  });
};